import { IConfigurationRegistry, IConfigurationService } from "../../domain/configuration";
import { ConfigurationService } from "./ConfigurationService";
import { ConfigurationRepository } from "./ConfigurationRepository";

export class ConfigurationRegistry implements IConfigurationRegistry {
  getConfigurationService(): IConfigurationService {
    return new ConfigurationService(this._repository);
  }

  private readonly _repository: ConfigurationRepository = new ConfigurationRepository();
}
